import {ActionReducerMap} from "@ngrx/store";

import * as fromAgencyList from '../agencys/store/agencys.reducer';
import * as fromAccountList from '../accounts/store/accounts.reducer';
import * as fromAuth from '../login/store/auth.reducer';
//import {State} from "../accounts/store/accounts.reducer";

export interface AppState {
  agencyList: fromAgencyList.State;
  accountList: fromAccountList.State;
  auth: fromAuth.State;
}

export const appReducer: ActionReducerMap<AppState> = {
  agencyList: fromAgencyList.agencyListReducer,
  accountList: fromAccountList.accountListReducer,
  auth: fromAuth.authReducer
}
